import { render } from "./ApplyingProject.vue?vue&type=template&id=70968e9c&scoped=true"
import script from "./ApplyingProject.vue?vue&type=script&lang=js"
export * from "./ApplyingProject.vue?vue&type=script&lang=js"

import "./ApplyingProject.vue?vue&type=style&index=0&id=70968e9c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70968e9c"]])

export default __exports__